import { FC } from 'react';
import { Image, Skeleton } from "antd";

import useInfoScreen from '../../useInfoScreen';
import { EditableContent } from "../EditableContent";
import { ScreenButtons } from "../ScreenButtons";
import { ScreenButton } from "../ScreenButton";
import { ScreenLayout } from "../ScreenLayout";
import phone from "../../images/phone.png";
import styles from './index.module.scss'

export const FirstViewOrdersScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return(
    <ScreenLayout>
      <Image
        className={styles.image}
        width={257}
        height={224}
        alt="profile"
        preview={false}
        src={phone}
      />
      <div className={styles.body}>
        <EditableContent type="header" maxLength={90} onSave={onEdit}>
          {data?.header}
        </EditableContent>
        <EditableContent type="body" maxLength={130} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
      <ScreenButtons>
        <ScreenButton>
          Выбрать
        </ScreenButton>
        <ScreenButton type="ghost">
          Пропустить
        </ScreenButton>
      </ScreenButtons>
    </ScreenLayout>
  )
}